import { InventoryAdjustmentType } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

export const INVENTORY_ADJUSTMENT_TYPE_OPTIONS: Option<string>[] = [
  { value: InventoryAdjustmentType.AdjustQuantity, label: "Adjust Quantity" },
  { value: InventoryAdjustmentType.SplitPallets, label: "Split Pallet(s) — Work in Progress", disabled: true },
  { value: InventoryAdjustmentType.CombinePallets, label: "Combine Pallets — Work in Progress", disabled: true },
  {
    value: InventoryAdjustmentType.LotBatchCorrection,
    label: "Lot/Batch Correction — Work in Progress",
    disabled: true,
  },
  { value: InventoryAdjustmentType.AddNewPallets, label: "Add New Pallet(s) — Work in Progress", disabled: true },
]
